/* ============================================================
   HERO MÓVIL — El Escaparate  +  Caché Match (las dos vistas)
   ------------------------------------------------------------
   El escaparate es una cámara sobre la MISMA foto del hero: cada botella
   queda bajo un foco. Los datos de los 8 perfumes viven en el slider
   (data-* de cada .chip) y de ahí salen los puntos, la ficha y el popup.
   ============================================================ */
/* ⚠️ EN EL PERSONALIZADOR las secciones se repintan sin recargar la página, así que este
   archivo NO se vuelve a ejecutar y el escaparate quedaría muerto. Por eso el cuerpo vive
   en una función que se vuelve a llamar con cada shopify:section:load.

   Los listeners que van en document/window sí sobrevivirían al repintado, y apuntarían a
   nodos que ya no están: se registran con la señal de un AbortController y al montar de
   nuevo se aborta la instancia anterior. Es la única forma de soltar listeners anónimos. */
var abortar = null;
/* ⚠️ La marca de "ya montado" va en un WeakSet y NO en un data-* del elemento: un atributo
   se serializa con el innerHTML, así que cualquier copia del marcado se llevaría el
   data-listo puesto y nacería creyéndose montada. Con el WeakSet la marca es del NODO. */
var montados = new WeakSet();

function montarEscaparate() {

  'use strict';

  var M = document.querySelector('.v-m');
  if (!M || montados.has(M)) return;      /* ya montado: nada que hacer */
  montados.add(M);

  if (abortar) abortar.abort();           /* desconecta la instancia anterior */
  abortar = new AbortController();
  var vive = { signal: abortar.signal };

  var $ = function (id) { return document.getElementById('m-' + id); };

  /* ==========================================================
     Datos: salen del propio slider, así el HTML es la única fuente
     ========================================================== */
  var rail  = $('rail');
  var chips = Array.prototype.slice.call(rail.querySelectorAll('.chip'));
  var stage = $('stage');
  var lens  = $('lens');
  var sheet = $('sheet');
  var items = chips.map(function (chip) {
    var cs = getComputedStyle(chip);
    return {
      el:     chip,
      key:    chip.dataset.key,
      sku:    chip.dataset.sku,
      name:   chip.dataset.name,
      brand:  chip.dataset.brand,
      price:  chip.dataset.price,
      size:   chip.dataset.size,
      family: chip.dataset.family,
      notes:  chip.dataset.notes,
      url:    chip.dataset.url || '',
      tags:   (chip.dataset.tags || '').split(' ').filter(Boolean),
      /* La foto recortada la pone Liquid en la miniatura del slider: de ahí la
         copian la ficha y el resultado del popup. Un solo <img> por perfume. */
      shot:   (chip.querySelector('.chip__crop img') || {}).src || '',
      /* Las coordenadas se leen del CSS (bloque 5): un solo sitio para la geometría */
      x:  parseFloat(cs.getPropertyValue('--x')),
      y:  parseFloat(cs.getPropertyValue('--y')),
      cx: parseFloat(cs.getPropertyValue('--cx')),
      cy: parseFloat(cs.getPropertyValue('--cy')),
      h:  parseFloat(cs.getPropertyValue('--h')) || 1
    };
  });


  var PHOTO_K = 1324 / 1920;      /* alto de la foto respecto de su ancho */
  var current = -1;
  var fromRail = false;           /* evita que el slider y la cámara se peleen */

  /* ==========================================================
     Los puntos: se crean a partir de los mismos datos
     ========================================================== */
  items.forEach(function (it, i) {
    var dot = document.createElement('button');
    dot.className = 'dot';
    /* ⚠️ La geometría ya no vive en el CSS: cada perfume la trae en su propio style
       (la escribe Liquid desde el schema del bloque). Por eso el punto se la copia:
       si no, nacería sin --x/--y y se apilarían los 8 en la esquina. */
    dot.style.setProperty('--x', it.x + '%');
    dot.style.setProperty('--y', it.y + '%');
    dot.style.setProperty('--h', it.h);
    dot.type = 'button';
    dot.setAttribute('aria-label', 'View ' + it.name);
    dot.addEventListener('click', function (e) { e.stopPropagation(); select(i); });
    lens.appendChild(dot);
    it.dot = dot;
  });

  /* ==========================================================
     La cámara
     ------------------------------------------------------------
     La foto se amplía --z veces. Con ese zoom, por la ventana se ve
     100/z % del ancho de la foto, así que el centro de la cámara no puede
     acercarse al borde más de la mitad de eso: si no, entraría relleno vacío.
     Por eso el punto al que apunta se recorta (clamp) y después se calcula
     dónde queda la botella dentro de la ventana, para llevar allí el foco
     y la pastilla del precio.
     ========================================================== */
  function frame(it) {
    var r  = stage.getBoundingClientRect();
    if (!r.width) return;                 /* la vista está oculta: no hay nada que medir */

    var z  = parseFloat(getComputedStyle(stage).getPropertyValue('--z')) || 3;
    var pw = r.width * z;                 /* ancho de la foto ya ampliada, en px */
    var ph = pw * PHOTO_K;

    var halfW = 50 * r.width  / pw;       /* medio campo visible, en % de la foto */
    var halfH = 50 * r.height / ph;

    var cxu = halfW >= 50 ? 50 : Math.min(Math.max(it.cx, halfW), 100 - halfW);
    var cyu = halfH >= 50 ? 50 : Math.min(Math.max(it.cy, halfH), 100 - halfH);

    /* Dónde cae la botella dentro de la ventana, en px */
    var sx = r.width  / 2 + (it.x - cxu) / 100 * pw;
    var sy = r.height / 2 + (it.y - cyu) / 100 * ph;

    /* La pastilla del precio no debe salirse por los lados */
    var tagX = Math.min(Math.max(sx, 78), r.width - 78);

    stage.style.setProperty('--cxu', cxu + '%');
    stage.style.setProperty('--cyu', cyu + '%');
    stage.style.setProperty('--sx', sx.toFixed(1) + 'px');
    stage.style.setProperty('--sy', sy.toFixed(1) + 'px');
    lens.style.setProperty('--cxu', cxu + '%');
    lens.style.setProperty('--cyu', cyu + '%');
    stage.style.setProperty('--tagx', tagX.toFixed(1) + 'px');
  }

  /* ==========================================================
     Seleccionar un perfume
     ========================================================== */
  function select(i, silent) {
    if (i === current) return;
    var prev = current;
    current = i;
    var it = items[i];

    frame(it);

    if (prev !== -1) {
      stage.classList.remove('is-moving');
      void stage.offsetWidth;                 /* reinicia el destello */
      stage.classList.add('is-moving');
    }

    $('s-brand').textContent = it.brand;
    $('s-name').textContent  = it.name;
    $('s-price').textContent = it.price;
    $('s-size').textContent  = it.size;
    $('f-family').textContent = it.family;
    $('f-size').textContent   = it.size;
    $('f-notes').textContent  = it.notes;
    $('f-body').style.setProperty('--h', it.h);   /* alto real de la botella */
    $('f-shot').src           = it.shot;
    $('f-shot').alt           = it.name;
    $('f-price').textContent  = it.price;

    /* Contrato de datos del carrito: la ficha ES la tarjeta del perfume activo.
       js/cart.js lee estos atributos del ancestro [data-sku] del botón Add. */
    sheet.dataset.sku   = it.sku;
    sheet.dataset.name  = it.name;
    sheet.dataset.price = it.price.replace(/[^0-9.]/g, '');
    sheet.dataset.img   = it.shot;

    items.forEach(function (o, k) {
      var on = k === i;
      o.el.classList.toggle('is-on', on);
      o.el.setAttribute('aria-pressed', on ? 'true' : 'false');
      o.dot.classList.toggle('is-on', on);
    });

    $('prev').disabled = i === 0;
    $('next').disabled = i === items.length - 1;

    /* Favorito: es por perfume, así que se reinicia al cambiar */
    $('like').classList.toggle('is-on', !!it.liked);
    $('like').setAttribute('aria-pressed', it.liked ? 'true' : 'false');

    if (!silent) centerChip(it.el);
  }

  function centerChip(el) {
    fromRail = true;
    var target = el.offsetLeft - (rail.clientWidth - el.offsetWidth) / 2;
    rail.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    clearTimeout(centerChip.t);
    centerChip.t = setTimeout(function () { fromRail = false; }, 820);
  }

  chips.forEach(function (chip, i) {
    chip.addEventListener('click', function () { select(i); });
  });

  /* Deslizar el slider mueve la cámara: gana la tarjeta más cercana al centro */
  var railTick;
  rail.addEventListener('scroll', function () {
    $('hint').classList.add('is-off');
    if (fromRail) return;
    cancelAnimationFrame(railTick);
    railTick = requestAnimationFrame(function () {
      var mid = rail.scrollLeft + rail.clientWidth / 2;
      var best = 0, bestD = Infinity;
      chips.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      select(best, true);
    });
  }, { passive: true });

  /* Flechas y swipe sobre la foto */
  $('prev').addEventListener('click', function () { if (current > 0) select(current - 1); });
  $('next').addEventListener('click', function () { if (current < items.length - 1) select(current + 1); });

  var sx0 = 0, sy0 = 0, tracking = false;
  stage.addEventListener('pointerdown', function (e) {
    tracking = true; sx0 = e.clientX; sy0 = e.clientY;
  });
  stage.addEventListener('pointerup', function (e) {
    if (!tracking) return;
    tracking = false;
    var dx = e.clientX - sx0, dy = e.clientY - sy0;
    if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
    if (dx < 0 && current < items.length - 1) select(current + 1);
    if (dx > 0 && current > 0) select(current - 1);
  });
  stage.addEventListener('pointercancel', function () { tracking = false; });

  /* Teclado: sólo cuando el escaparate se está viendo */
  document.addEventListener('keydown', function (e) {
    if (!modal.hidden || !enMovil()) return;
    if (e.key === 'ArrowRight' && current < items.length - 1) select(current + 1);
    if (e.key === 'ArrowLeft'  && current > 0) select(current - 1);
  }, vive);

  /* ⚠️ La cámara se calcula en PÍXELES, así que hay que rehacerla cada vez que el
     escaparate cambia de tamaño — y también al CRUZAR el punto de vistas: en escritorio
     .v-m está en display:none y stage mide 0, con lo que frame() no puede colocar nada. */
  var mq = window.matchMedia('(max-width:767.98px)');
  function enMovil() { return mq.matches; }
  var rz;
  function recalcular() {
    clearTimeout(rz);
    rz = setTimeout(function () { if (current !== -1) frame(items[current]); }, 120);
  }
  window.addEventListener('resize', recalcular, vive);
  if (mq.addEventListener) mq.addEventListener('change', recalcular, vive);
  else if (mq.addListener) mq.addListener(recalcular);

  /* HOM-004: arranca con el primer perfume elegido. Sin esto la ficha quedaba
     vacía ("Add ·" sin nombre ni precio) hasta tocar una miniatura.
     silent: sin centrar el carril, para no mover la página al cargar. */
  if (items.length && current === -1) select(0, true);

  /* ==========================================================
     Favoritos y avisos  (el carrito lo maneja js/cart.js)
     ========================================================== */
  function toast(msg) {
    var t = $('toast');
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toast.t);
    toast.t = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }
  $('like').addEventListener('click', function () {
    var it = items[current];
    it.liked = !it.liked;
    this.classList.toggle('is-on', it.liked);
    this.setAttribute('aria-pressed', it.liked ? 'true' : 'false');
    toast(it.liked ? 'Saved to favorites' : 'Removed from favorites');
  });

  /* ==========================================================
     Caché Match: 3 preguntas, una recomendación
     ------------------------------------------------------------
     ⚠️ Es el MISMO popup para las dos vistas: en móvil entra como cajón desde
     abajo y en escritorio como tarjeta centrada (sólo cambia el CSS). Lo abren
     el botón del hero móvil y el CTA del dorso de la tarjeta que gira.

     Cada respuesta suma puntos a los perfumes que llevan esa etiqueta
     (data-tags en el slider). La familia pesa el doble porque es lo que
     más se nota al olerlo.
     ========================================================== */
  /* Las 3 preguntas. Se pueden pisar desde la sección con
     window.CACHE_MATCH_QUESTIONS antes de este archivo. */
  var QUESTIONS = window.CACHE_MATCH_QUESTIONS || [
    { title: 'When will you wear it?', weight: 1, opts: [
      { label: 'In the daytime', hint: 'Office, errands, sun',  tag: 'day' },
      { label: 'After dark',     hint: 'Dinners, nights out',   tag: 'night' }
    ]},
    { title: 'What do you like to smell?', weight: 2, opts: [
      { label: 'Fresh and citrus', hint: 'Clean, light',        tag: 'fresh' },
      { label: 'Sweet and fruity', hint: 'Vanilla, red fruits', tag: 'sweet' },
      { label: 'Spicy',            hint: 'Cinnamon, amber',     tag: 'spicy' },
      { label: 'Floral',           hint: 'Rose, jasmine',       tag: 'floral' }
    ]},
    { title: 'How much presence?', weight: 1, opts: [
      { label: 'Subtle',        hint: 'Close to the skin',      tag: 'soft' },
      { label: 'Balanced',      hint: 'Noticed, never loud',    tag: 'medium' },
      { label: 'Leave a trail', hint: 'Long projection',        tag: 'strong' }
    ]}
  ];

  var modal   = $('match-modal');
  /* El popup de 3 preguntas se retiró del liquid: si no está en la página,
     salimos sin tocar nada. El de 8 preguntas vive en cache-match.js. */
  if (!modal) return;
  var qStep   = $('q-step'), qTitle = $('q-title'), qOpts = $('q-opts');
  var step = 0, score = [], picked = [], ultimoFoco = null;

  function resetQuiz() {
    step = 0;
    score = items.map(function () { return 0; });
    picked = [];
    $('res').classList.remove('is-on');
    $('q-wrap').style.display = '';
    paint();
  }

  function paint() {
    var q = QUESTIONS[step];
    qStep.textContent = 'Step ' + (step + 1) + ' of ' + QUESTIONS.length;
    qTitle.textContent = q.title;
    qOpts.innerHTML = '';
    q.opts.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'q__opt';
      b.appendChild(document.createTextNode(o.label));
      var s = document.createElement('span');
      s.textContent = o.hint;
      b.appendChild(s);
      b.addEventListener('click', function () { answer(o); });
      qOpts.appendChild(b);
    });
  }

  function answer(opt) {
    var w = QUESTIONS[step].weight;
    items.forEach(function (it, i) {
      if (it.tags.indexOf(opt.tag) !== -1) score[i] += w;
    });
    picked.push(opt.label.toLowerCase());
    step++;
    if (step < QUESTIONS.length) { paint(); return; }

    var best = 0;
    score.forEach(function (v, i) { if (v > score[best]) best = i; });
    var it = items[best];

    $('q-wrap').style.display = 'none';
    $('res').classList.add('is-on');
    $('res-crop').style.setProperty('--h', it.h);
    $('res-shot').src = it.shot;
    $('res-shot').alt = it.name;
    $('res-name').textContent = it.name;
    $('res-price').textContent = it.price + ' · ' + it.size;
    $('res-why').textContent = 'Based on what you picked (' + picked.join(', ') + '), this is the closest one.';
    $('res-go').onclick = function () {
      /* Si el perfume está asociado a un producto real, vamos a su página.
         Si no lo está (maqueta), caemos al comportamiento viejo: cerrar el
         popup y resaltar su punto sobre la foto del hero. */
      if (it.url) { window.location.href = it.url; return; }
      closeModal();
      mostrar(best);
    };
  }

  /* Llevar al perfume elegido: en móvil es el escaparate; en escritorio, su punto
     sobre la foto del hero. Un solo camino para las dos vistas. */
  function mostrar(i) {
    var it = items[i];
    if (enMovil()) {
      select(i);
      $('escaparate').scrollIntoView({ block: 'start', behavior: 'smooth' });
      return;
    }
    var punto = document.querySelector('.hotspot[data-perfume="' + it.key + '"]');
    var hero  = document.querySelector('.v-d .hero');
    if (hero) hero.scrollIntoView({ block: 'start', behavior: 'smooth' });
    if (punto) {
      setTimeout(function () {
        var boton = punto.querySelector('.hotspot__dot');
        if (boton) boton.click();
      }, 520);
    }
  }

  function openModal(disparador) {
    ultimoFoco = disparador || document.activeElement;
    resetQuiz();
    modal.hidden = false;
    void modal.offsetHeight;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    modal.querySelector('.mq__close').focus();
  }
  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { modal.hidden = true; }, 420);
    if (ultimoFoco && document.contains(ultimoFoco)) ultimoFoco.focus();
  }

  /* Lo abren los dos: el botón del hero móvil y el CTA de la tarjeta que gira */
  document.querySelectorAll('[data-match-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openModal(btn);
    });
  });
  $('res-again').addEventListener('click', resetQuiz);
  modal.querySelectorAll('[data-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  }, vive);

  /* ==========================================================
     Arranque
     ========================================================== */
  function boot() { select(0); frame(items[0]); }
  var photo = lens.querySelector('img');
  if (photo.complete) boot();
  else photo.addEventListener('load', boot, { once: true });
  window.addEventListener('load', function () { if (current !== -1) frame(items[current]); }, vive);
}

montarEscaparate();
document.addEventListener('shopify:section:load', function () { montarEscaparate(); });
